import { t } from '@lingui/macro';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className='toaster group'
      position='top-right'
      toastOptions={{
        classNames: {
          toast:
            'group toast glass-toast group-[.toaster]:bg-slate-950/80 group-[.toaster]:backdrop-blur-xl group-[.toaster]:border-white/10 group-[.toaster]:text-slate-50 group-[.toaster]:shadow-2xl dark:group-[.toaster]:bg-slate-950/80 rounded-xl',
          description: t({
            id: 'shared.ui.sonner.description-group-toast-text-slate',
            message: 'group-[.toast]:text-slate-300',
          }),
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-medium',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground font-medium',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
